import { generatePopup } from "../../utility/popup";
import * as actionTypes from "../ActionTypes";
import { apiDelete, apiGet, apiPost, apiPut } from "../axios";

export const AddTransfers = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.ADD_TRANSFER_INIT,
    });

    try {
      const response = await apiPost("transfers", payload, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.ADD_TRANSFER_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.ADD_TRANSFER_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 401) {
        dispatch({
          type: actionTypes.ADD_TRANSFER_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const GetTransfers = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_TRANSFER_INIT,
    });

    try {
      const response = await apiGet(
        `transfers?page=${payload?.page}&limit=${payload?.limit}&search=${payload?.search}`,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_TRANSFER_SUCCESS,
          payload: response.data,
        });
        // generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.GET_TRANSFER_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 401) {
        dispatch({
          type: actionTypes.GET_TRANSFER_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const DeleteTransfers = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_TRANSFER_INIT,
    });

    try {
      const response = await apiDelete(`transfers/${payload}`, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.DELETE_TRANSFER_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.DELETE_TRANSFER_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.DELETE_TRANSFER_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.DELETE_TRANSFER_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const UpdateTransfers = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_TRANSFER_INIT,
    });

    try {
      const response = await apiPut(
        `transfers/${payload.id}`,
        payload.data,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.UPDATE_TRANSFER_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.UPDATE_TRANSFER_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.UPDATE_TRANSFER_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 403) {
        dispatch({
          type: actionTypes.UPDATE_TRANSFER_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.UPDATE_TRANSFER_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.UPDATE_TRANSFER_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};
